<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    :storeModule="AuthNPoliciesCollection"
  />
</template>

<script>
import * as Constants from 'client/util/Constants';
import { DropDownSectionConsts } from 'client/util/Constants';
import { authnPolicyType, authnPolicyTypeLabel } from 'client/Security/AuthNPolicyType';
import { mapActions, mapGetters } from 'vuex';
import AuthNPoliciesFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/AuthNPoliciesFilters';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;
const authNPoliciesCollection = StoreModuleMap[ItemTypeConsts.authNPolicies];
const { selectOne } = DropDownSectionConsts;
const { application, userportal, ldap } = authnPolicyType;
const PolicyLabels = authnPolicyTypeLabel;
export default {
  name: 'AuthNPoliciesDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data: () => ({
    AuthNPoliciesCollection: authNPoliciesCollection,
  }),

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters(authNPoliciesCollection, [
      'getFilters',
    ]),
    dropDownMenuSections() {
      const menus = [
        {
          menuLabel: 'policy type:',
          menuType: selectOne,
          menuItems: [
            {
              filter: AuthNPoliciesFilters.userPortalType(),
              label: PolicyLabels[userportal],
              action: () => {
                this.handleDropDownAction(AuthNPoliciesFilters.userPortalType());
              },
            },
            {
              filter: AuthNPoliciesFilters.ssoApplicationType(),
              label: PolicyLabels[application],
              action: () => {
                this.handleDropDownAction(AuthNPoliciesFilters.ssoApplicationType());
              },
            },
            {
              filter: AuthNPoliciesFilters.ldapType(),
              label: PolicyLabels[ldap],
              action: () => {
                this.handleDropDownAction(AuthNPoliciesFilters.ldapType());
              },
            },
          ],
        },
      ];

      return menus;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions(authNPoliciesCollection, [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
